import React, { useEffect, useState } from "react";
import InnerBannerBreadcrumb from "../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import { useSelector } from "react-redux";
import { useGetProtectedApiDataQuery } from "../../redux/services/apiSlice";
import SwachhVidyalayaTabs from "./SwachhVidyalayaTabs";
import Loader from "../../components/Loader";

import "datatables.net";
import IndexSVA from "./IndexSVA";
import SwachhVidyalayaComponent from "./SwachhVidyalayaComponent";

const SwachhVidyalayaAbhiyanPage = () => {
  const { getText } = useLanguageTranslation();
  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage="images/inner_aboutbann.jpg"
        title={getText("Swachh Vidyalaya Ahbiyan", "स्वच्छ विद्यालय अभियान")}
        titleLink="/swachh-vidyalaya-abhiyan"
        levelTwo={false}
        levelThree={false}
        isActive={getText("Swachh Vidyalaya Ahbiyan", "स्वच्छ विद्यालय अभियान")}
      />
      <div className="inner-container">
        <div className="container">
          <div className="container">
            {/* <PageLastUpdated lastUpdatedOn={lastUpdated} /> */}
            <SwachhVidyalayaComponent />
          </div>
        </div>
      </div>
    </>
  );
};

export default SwachhVidyalayaAbhiyanPage;
